import React from 'react';

import { Callout as RadixCallout } from '@radix-ui/themes';
import classNames from 'classnames';

import { IconButton } from '../IconButton';
import { Text } from '../Text';
import { getFlyToRadixColor, renderIcon } from '../utils';
import { CalloutProps } from './Callout.types';

const sizeToClassNameMap = {
  '1': 'rounded-fly-4',
  '2': 'rounded-fly-5',
  '3': 'rounded-fly-5',
};

const sizeTotTitleSizeMap = {
  '1': '2',
  '2': '2',
  '3': '3',
} as const;

function Callout({
  icon = null,
  iconSize = 16,
  title,
  color = 'accent',
  onClose,
  children,
  className = '',
  variant = 'soft',
  size = '2',
  isToast = false,
  ref,
  ...rest
}: CalloutProps & { ref?: React.Ref<HTMLDivElement> }) {
  const showLeadingRow =
    Boolean(icon) || Boolean(title) || Boolean(onClose && !isToast);

  return (
    <RadixCallout.Root
      {...rest}
      size={size}
      variant={variant}
      color={getFlyToRadixColor(color)}
      className={classNames(
        'flex items-center gap-fly-4 rounded-fly-4',
        className,
        isToast ? 'flex-row' : 'flex-col',
        (sizeToClassNameMap as any)[size]
      )}
      ref={ref}
    >
      {showLeadingRow && (
        <RadixCallout.Icon
          className={classNames('h-[unset]', !isToast ? 'w-full' : 'w-fit')}
        >
          <div
            className={classNames('flex w-full gap-fly-3', {
              '!items-center': isToast,
            })}
          >
            {icon && renderIcon(icon, iconSize, 'mt-[2px]')}
            {title && (
              <Text
                size={
                  sizeTotTitleSizeMap[
                    size as keyof typeof sizeTotTitleSizeMap
                  ] || '2'
                }
                className='flex-1'
                color={color}
              >
                {title}
              </Text>
            )}
            {onClose && !isToast && (
              <IconButton
                data-testid='callout-close-btn'
                size='1'
                variant='ghost'
                icon='cross'
                color='neutral'
                onClick={onClose}
              />
            )}
          </div>
        </RadixCallout.Icon>
      )}
      {children}
      {onClose && isToast && (
        <IconButton
          data-testid='callout-close-btn'
          size='1'
          variant='ghost'
          icon='cross'
          color='neutral'
          onClick={onClose}
        />
      )}
    </RadixCallout.Root>
  );
}

export { Callout };
